/**
 * Sets the drag image to the given element, centered on the cursor.
 */
export const setDragImageToCenterOfElement = (dataTransfer: DataTransfer, element: HTMLElement) => {
  const rect = element.getBoundingClientRect();
  dataTransfer.setDragImage(element, rect.width / 2, rect.height / 2);
};
